import Emoji from "@core-components/emoji/Emoji";
import InfoArea from "@core-components/info-area/InfoArea";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack } from "@mantine/core";
import { Trans } from "react-i18next";

export const SmurfsNormalInfo = () => {
  const { t } = useAppTranslation("pages.normal");
  const { currentRegion } = useAppRegion();

  return (
    <>
      <Stack className="px-3">
        <InfoArea
          hasShadow
          className="!p-10"
          description={
            <Trans
              i18nKey="pages.normal.infoAreaWhy.description"
              values={{ region: currentRegion.toUpperCase() }}
            >
              Nous aimons tous voir notre classement augmenter dans League of
              Legends, chaque semaine nous nous lançons sur la Faille de
              l&apos;invocateur pour une partie classée dans le but de monter
              d&apos;un rang, mais nous savons tous qu&apos;il y a des facteurs
              que nous ne pouvons pas contrôler qui déterminent si nous gagnons
              les parties ou non.
              <br />
              <br />
              Cependant, il y a beaucoup de choses qui sont sous notre contrôle,
              comme posséder un second compte lol. Vous vous demandez peut-être,
              comment posséder un compte smurf peut m&apos;aider à gagner de
              l&apos;elo? Eh bien, la réponse est simple, l&apos;un des plus
              grands facteurs de perte de parties dans League of Legends est de
              jouer sur votre compte principal lorsque vous êtes énervé. <br />
              Peut-être avez-vous eu un mauvais joueur dans la jungle lors
              d&apos;une partie classée, il ne vous a pas aidé une seule fois
              pendant toute la partie et vous avez perdu, alors que faites-vous
              ? Eh bien, naturellement, ce que beaucoup d&apos;entre nous font,
              c&apos;est simplement se mettre en file d&apos;attente pour une
              autre partie tout en étant énervé, c&apos;est une grande erreur !
              <br /> On sait depuis longtemps maintenant que les challengers et
              les pros les mieux classés restent en haut de l&apos;échelle en
              possédant plusieurs comptes smurfs, prenez par exemple Caps des
              Fnatics, il a un compte classé dans le top 10 et ensuite plus de 5
              comptes en dessous de cela, la raison pour laquelle il peut rester
              si haut en haut sur son compte principal est que chaque fois
              qu&apos;il sent qu&apos;il ne joue pas à son meilleur niveau, il
              peut facilement passer à un autre compte lol.
            </Trans>
          }
          headLine={
            <SSHeadline
              props={{
                stack: {
                  className: "w-full",
                  align: "left",
                },
              }}
            >
              <Emoji.Fire />
              <SSLoLGradientText>
                {" "}
                {t("infoAreaWhy.headlinePrefix")}{" "}
              </SSLoLGradientText>
              <SSWhiteText>
                {t("infoAreaWhy.headlineSuffix", {
                  region: currentRegion.toUpperCase(),
                })}
              </SSWhiteText>
            </SSHeadline>
          }
        />
      </Stack>

      <InfoArea
        hasShadow
        className="!p-10 !mb-20"
        description={
          <Trans
            i18nKey="pages.normal.infoAreaSmurf.description"
            values={{ region: currentRegion.toUpperCase() }}
          >
            Ce compte LoL Smurf non classé est au niveau 30, avec un MMR
            complètement frais, sans aucun match classé joué, il est livré avec
            plus de 40 000 essence bleue, suffisamment pour acheter des
            champions pour votre prochaine ascension !
            <br />
            <br />
            Ce compte LoL est non classé, ce qui signifie que vous avez la
            chance de monter dans une ligue supérieure après vos parties
            provisionnelles sur ce nouveau compte.
            <br />
            <br />
            Notre système de livraison automatique 24/7 enverra les informations
            de votre compte dans votre boite email en un instant après votre
            achat. En achetant un compte sur secretsmurf.com, vous bénéficiez
            d’une garantie à vie de remplacements en cas de bannissement lié au
            botting. Les achats sont définitifs et ne peuvent être remboursés.
          </Trans>
        }
        fullWidth={false}
        headLine={
          <SSHeadline>
            <Emoji.Pin />
            <SSWhiteText>
              {" "}
              {t("infoAreaSmurf.headline", {
                region: currentRegion.toUpperCase(),
              })}
            </SSWhiteText>
          </SSHeadline>
        }
      />
    </>
  );
};
